import { render, staticRenderFns } from "./VesselDocuments.vue?vue&type=template&id=25e6fa24&"
import script from "./VesselDocuments.vue?vue&type=script&lang=js&"
export * from "./VesselDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports